import { NgModule } from '@angular/core';

import { TranslateModule, TranslateLoader, TranslateStore } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { createTranslateLoader } from 'src/app/app.module';


const translationOptions = {
  loader: {
    provide: TranslateLoader,
    useFactory: createTranslateLoader,
    deps: [HttpClient]
  }
};

@NgModule({
  imports: [
    TranslateModule.forRoot(translationOptions)
  ],
  exports: [
    TranslateModule
  ],
  providers: [
    TranslateService,
    TranslateStore
  ]
})
export class AppTranslationModule {
  constructor(translate: TranslateService) {
    translate.setDefaultLang('ko-kr');
    translate.use('ko-kr');
  }
}
